import React from 'react';
import { connect } from 'react-redux';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';

function ReportContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/reports"
        pathPermissionId={UserPermissionsIds.AccessReports}
        render={(props) => ViewMounter(props, {
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
        allowAnonymous={undefined}
      />
      <SecureRoute
        path="/reports/corrections"
        pathPermissionId={UserPermissionsIds.ViewPatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/corrections',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/trainingstatus/:title"
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: { title: props.title, }
        },
        {
          viewPath: 'reports/no_parameter',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/transporterlist/:dispenser"
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: { dispenser: props.dispenser }
        },
        {
          viewPath: 'reports/no_parameter',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/user/:title?"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: { title: props.title, }
        },
        {
          viewPath: 'reports/admin/user',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/renewalrate"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/renewal_rates',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/dispensationsbymmtc"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/dispensations_mmtc',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/physicianpatientcounts"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/physician_patient_counts',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/physicianpatientcounts"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/physician_patient_counts',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/qualifiedpatientcaregivers"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/qualified_patient_caregivers',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/enrollments"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/enrollments',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/basiccountandpercentage"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/basic_count_percentage',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/applicationanalysis"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/admin/application_analysis',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/reports/insufficientmailingaddress"
        pathPermissionId={UserPermissionsIds.ReadAdminReports}
        exact
        render={(props) => ViewMounter(props, [{
          viewPath: 'reports/reports_list',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'reports/no_parameter',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    empty: state.empty,
  };
}

const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportContainerScreen);
